import React from 'react';
import {Badge, Button} from 'reactstrap';
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import {MdContentCopy, MdCreate, MdDelete} from 'react-icons/md';
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import ReactTooltip from "react-tooltip";
import {isSafari} from 'react-device-detect'

let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

const roundButton = {width: 50, height: 50, minWidth: 50, minHeight: 50, borderRadius: 25, padding: 0}

const ResourceTableRow = (props) => {

    const localize = function () {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    localize();
    return (
        <div className="bg-yellowopen" style={{
            display: "flex",
            flexFlow: "row",
            justifyContent: "space-between",
            alignItems: "center",
            color: "white",
            borderRadius: 40,
            marginBottom: 10,
            padding: 10
        }}>

            <div style={{
                display: "flex",
                flexFlow: "row",
                marginLeft: 10,
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap"
            }}>
                <div style={{fontWeight: 600, fontSize: "0.9rem"}}>
                    {props.item.name}
                </div>
                {!isSafari &&
                    <ReactTooltip/>
                }

                {props.item.membership &&
                <Badge color="white" style={{marginBottom: 10, marginLeft: 10}}>
                    {resourceStrings.membership}
                </Badge>
                }

                {props.item.is_enrolment &&
                <Badge color="white" style={{marginBottom: 10, marginLeft: 10}}>
                    {resourceStrings.is_enrolment}
                </Badge>
                }
            </div>

            <div style={{display: "flex", flexFlow: "row"}}>
                <Button
                    style={roundButton}
                    className="btn-icon ct-example-tooltip-static"
                    color="warning"
                    data-type="error"
                    data-tip={commonStrings.delete}
                    onClick={e => props.deleteItem(e, props.item.id)}>
                    <MdDelete/>
                </Button>

                {props.copyItem &&
                    <Button
                        style={roundButton}
                        color="secondary"
                        data-type="info"
                        data-tip={commonStrings.copy}
                        onClick={e => props.copyItem(e, props.item.id)}>
                        <MdContentCopy/>
                    </Button>
                }

                <Button
                    style={roundButton}
                    color="secondary"
                    data-type="info"
                    data-tip={commonStrings.edit}
                    onClick={e => props.editItem(e, props.item.id)}>
                    <MdCreate/>
                </Button>
            </div>
        </div>
    )
};

export default ResourceTableRow;